/**
 * @param {String} vertical from the Vertical enum (e.g. "RESTAURANTS")
 * @param {String} promoType string representing the promo type being upsold
 * @returns {Object} CDP event object
 */
export function clickPageUpsellCardPrimary(vertical, promoType) {
  return {
    name: 'Click Page Upsell Card Primary',
    properties: {
      feature: `${vertical}: ${promoType}`
    }
  };
}

/**
 * @param {String} vertical from the Vertical enum (e.g. "RESTAURANTS")
 * @param {String} promoType string representing the promo type being upsold
 * @returns {Object} CDP event object
 */
export function dismissPageUpsellCard(vertical, promoType) {
  return {
    name: 'Dismiss Page Upsell Card',
    properties: {
      feature: `${vertical}: ${promoType}`
    }
  };
}